/*
 * INTERNAL DEVELOPMENT NOTE
 * Final regulatory/compliance review must be performed by qualified Indian
 * securities-law counsel before production launch.
 *
 * Positioning constraints encoded here (do not alter without legal review):
 *  - Adviserz is a BRAND / TRADE NAME of Quant Core Technologies Private Limited.
 *  - Adviserz is NOT registered with SEBI as a Research Analyst or Investment Adviser.
 *  - No investment advice, no recommendations, no buy/sell calls, no performance claims.
 *  - No payment/checkout for research, signals or advisory services.
 */

export const COMPANY = {
  legalName: "Quant Core Technologies Private Limited",
  brand: "Adviserz",
  disclosure: "Adviserz is a brand name of Quant Core Technologies Private Limited.",
  business:
    "Financial technology, quantitative analytics and market intelligence platform.",
  address: "D250, 5th Floor, Dhindsa Tower 1, Sector 75, Mohali, Punjab, India",
  email: "info@adviserz.in",
  linkedin: "https://www.linkedin.com/company/adviserz/",
  x: "https://x.com/adviserzapp",
};

export const REGULATORY_NOTICE =
  "Regulatory Status: Adviserz, a brand of Quant Core Technologies Private Limited, is currently not registered with SEBI as a Research Analyst or Investment Adviser. The platform is being developed as a financial technology and market intelligence platform.";

export const FOOTER_DISCLAIMER =
  "Adviserz is currently not registered with SEBI as a Research Analyst or Investment Adviser. Information and analytics provided through this website are for informational, educational and analytical purposes only and do not constitute investment advice or a recommendation to buy or sell securities.";

export const FULL_DISCLAIMER =
  "Adviserz is a financial technology and market intelligence platform operated under the brand name of Quant Core Technologies Private Limited. Adviserz is currently not registered with the Securities and Exchange Board of India (SEBI) as a Research Analyst or Investment Adviser. The information, data, analytics, models, AI-generated outputs, research tools and market insights available on this website are provided for informational, educational and analytical purposes only and should not be construed as investment advice, research reports, recommendations, solicitation, or an offer to buy or sell any securities or financial instruments. Users should conduct their own research and consult a SEBI-registered financial professional before making investment decisions. Investments in securities and financial instruments are subject to market risks and past performance does not guarantee future results.";

export const AI_DISCLAIMER =
  "Adviserz uses artificial intelligence, machine learning, quantitative models and automated data-processing systems to generate analytical outputs and market intelligence. AI-generated or algorithmically generated information may contain errors, omissions, delays or inaccuracies. Such outputs should not be relied upon as a substitute for independent research or professional financial advice.";

export const AI_PERFORMANCE_NOTE =
  "Past model performance, back-tested results or simulated performance, where shown, do not guarantee future results.";

export const ANALYTICS_NOTE =
  "For informational and analytical purposes only. This content does not constitute investment advice or a recommendation to buy, sell or hold any security or financial instrument.";

export const PLATFORM_LINKS = [
  { to: "/technology", label: "Technology", blurb: "Platform architecture & data infrastructure" },
  { to: "/market-intelligence", label: "Market Intelligence", blurb: "Structured market analytics & context" },
  { to: "/quant-research", label: "Quant Research", blurb: "Statistical & derivatives research engine" },
  { to: "/ai-ml", label: "AI & ML", blurb: "Machine learning and modelling infrastructure" },
  { to: "/news-intelligence", label: "News Intelligence", blurb: "AI-assisted financial news analytics" },
];

export const LEGAL_LINKS = [
  { to: "/disclaimer", label: "Disclaimer" },
  { to: "/terms", label: "Terms & Conditions" },
  { to: "/privacy", label: "Privacy Policy" },
];

export const LEGAL_UPDATED = "June 2026";
